import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import CreateCompany from './createcompany';
import CreateMaster from './createmaster';
import Service from './Service';
import ProductMaster from './Product/product';
import TaxInvoice from './taxinvoice';
import { Typography, Container, useTheme, useMediaQuery } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import { Business, Settings, Build, Storefront, Description } from "@mui/icons-material";
import CompanyTable from './company/company';
import MasterTable from './master/master';
import ServiceTable from './service/service';
import Taxinvoice from './TaxInvoice/taxInvoice';

const StyledContainer = muiStyled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledTabs = muiStyled(Tabs)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  "& .MuiTabs-indicator": {
    height: 3,
    borderRadius: 1.5
  }
}));

const StyledTab = muiStyled(Tab)(({ theme }) => ({
  minHeight: 30,
  padding: theme.spacing(2),
  minWidth: 120,
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    transform: "translateY(-2px)"
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.light,
    color: "white",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: "100%"
  }
}));

const tabConfig = [
  {
    label: "Company",
    icon: <Business size={24} />,
    route: "/einvoice/company",
    component: (props) => <CompanyTable {...props} />
  },
  {
    label: "Master",
    icon: <Settings size={24} />,
    route: "/einvoice/master",
    component: (props) => <MasterTable {...props} />
  },
  {
    label: "Services",
    icon: <Settings size={24} />,
    route: "/einvoice/services",
    component: (props) => <ServiceTable {...props} />
  },
  {
    label: "Product",
    icon: <Storefront size={24} />,
    route: "/einvoice/product",
    component: (props) => <ProductMaster {...props} />
  },
  // { 
  //   label: "Tax Invoice", 
  //   icon: <Description size={24} />, 
  //   route: "/einvoice/tax-invoice",
  //   component: (props) => <TaxInvoice {...props} />
  // },
  {
    label: "Tax Invoice",
    icon: <Description size={24} />,
    route: "/einvoice/tax-invoice",
    component: (props) => <Taxinvoice {...props} />
  }
];

const Einvoice = ({ handleClose }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Set the initial tab based on the current URL when component mounts
  useEffect(() => {
    console.log("e invoice tabs use effect is calling.............")
    const currentPath = window.location.pathname;
    if (['/einvoice/company', '/einvoice/master', '/einvoice/services', '/einvoice/product', '/einvoice/tax-invoice'].includes(currentPath)) {
      const tabIndex = tabConfig.findIndex(tab => currentPath.includes(tab.route.split('/').pop()));
      if (tabIndex !== -1) {
        setSelectedTab(tabIndex);
      } else {
        // Default to first tab if no match is found
        window.history.pushState({}, '', tabConfig[0].route);
      }
    }
  }, []);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Update URL without full page reload
    window.history.pushState({}, '', tabConfig[newValue].route);
  };

  return (
    <>
      <StyledContainer>
        <StyledTabs
          value={selectedTab}
          onChange={handleChange}
          orientation={isMobile ? "vertical" : "horizontal"}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="navigation tabs"
        >
          {tabConfig.map((tab, index) => (
            <StyledTab
              key={index}
              icon={tab.icon}
              label={tab.label}
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
              iconPosition="start"
            />
          ))}
        </StyledTabs>
      </StyledContainer>
      <Box sx={{ mt: 2 }}>
        {tabConfig[selectedTab].component({ handleClose })}
      </Box>
    </>
  );
};

export default Einvoice;